import { render } from "./TableUserAsociates.vue?vue&type=template&id=15eac65e&scoped=true"
import script from "./TableUserAsociates.vue?vue&type=script&lang=js"
export * from "./TableUserAsociates.vue?vue&type=script&lang=js"

import "./TableUserAsociates.vue?vue&type=style&index=0&id=15eac65e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15eac65e"]])

export default __exports__